import React, { useState } from 'react';
import './FeedbackModal.css';
import AmplitudeTracker from './Amplitude';

const RATINGS = [
  { value: 'bad', emoji: '😠', label: 'Bad' },
  { value: 'ok', emoji: '😐', label: 'OK' },
  { value: 'great', emoji: '😊', label: 'Great' },
];

function FeedbackModal({ isOpen, onClose }) {
  const [rating, setRating] = useState(null);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!rating || status === 'submitting') return;
    setStatus('submitting');

    try {
      const res = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          rating,
          message,
          page: window.location.pathname,
          website: '', // honeypot — must stay empty
        }),
      });

      if (res.ok) {
        AmplitudeTracker.trackFeedbackSubmitted(rating, !!message);
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const handleClose = () => {
    setRating(null);
    setMessage('');
    setStatus('idle');
    onClose();
  };

  return (
    <div className="modal-overlay feedback-overlay" onClick={handleClose}>
      <div className="feedback-modal" onClick={e => e.stopPropagation()}>
        <button className="feedback-close" onClick={handleClose} aria-label="Close">✕</button>

        {status === 'success' ? (
          <div className="feedback-success">
            <div className="feedback-success-icon">🎉</div>
            <h2>Thanks for the feedback!</h2>
            <p>It helps us make Topamine better.</p>
            <button className="feedback-submit" onClick={handleClose}>Close</button>
          </div>
        ) : (
          <>
            <h2>Send Feedback</h2>
            <p className="feedback-subtitle">How do you like the game?</p>

            <div className="feedback-ratings">
              {RATINGS.map(r => (
                <button
                  key={r.value}
                  className={`feedback-emoji-btn ${rating === r.value ? 'selected' : ''}`}
                  onClick={() => setRating(r.value)}
                  aria-label={r.label}
                  title={r.label}
                >
                  <span className="feedback-emoji">{r.emoji}</span>
                  <span className="feedback-emoji-label">{r.label}</span>
                </button>
              ))}
            </div>

            <textarea
              className="feedback-textarea"
              placeholder="Tell us more… (optional)"
              value={message}
              onChange={e => setMessage(e.target.value.slice(0, 500))}
              rows={3}
              maxLength={500}
            />

            {status === 'error' && (
              <p className="feedback-error">Something went wrong. Please try again.</p>
            )}

            {/* Honeypot — hidden from real users */}
            <input
              type="text"
              name="website"
              style={{ display: 'none' }}
              tabIndex={-1}
              aria-hidden="true"
              readOnly
              value=""
            />

            <button
              className="feedback-submit"
              onClick={handleSubmit}
              disabled={!rating || status === 'submitting'}
            >
              {status === 'submitting' ? 'Sending…' : 'Submit'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default FeedbackModal;
